import React, { useEffect, useState } from 'react';
import { Button, TextField ,Typography} from '@mui/material/';
import { Loader } from "@googlemaps/js-api-loader"



export default function MapAddress({defaultAddress,changeAddress}) {


  const [searchValue, setSearchValue] = useState('');
  const [erreurGoogle, setErreurGoogle] = React.useState("");

  const center = { lat:46.6514247, lng: -73.3972788 };
  const loader = new Loader({
    apiKey: "AIzaSyCPrh3MbwDLMu3bIZmV4dWAof5KWjbiP4g",
    version: "weekly",
    libraries: ["places"]
  });

  
  useEffect(() => {
   
    //defaultAddress = "38 Charles St E, Toronto, ON M4Y 1T1, Canada";
    //setSearchValue(defaultAddress);
    console.log("defaultAddress:" + defaultAddress);

    loader.load().then(() => {

      const google = window.google;
      const mapInstance = new google.maps.Map(document.getElementById("map"), {
        center,
        zoom: 6
      });

      const autocompleteInstance = new google.maps.places.Autocomplete(
        document.getElementById("search-input"), 
        {       
            componentRestrictions: { country: "ca"},
            //fields: ["place_id", "geometry",  "name"],
            //types: ["establishment"],
        }
      );

      
      autocompleteInstance.addListener("place_changed", () => {
        
           const selectedPlace = autocompleteInstance.getPlace();
           console.log("selectedPlace:",selectedPlace);
           setSearchValue(selectedPlace.formatted_address);

           if(selectedPlace.types.includes("subpremise") === true ||
                   selectedPlace.types.includes("premise")=== true  ||
                   selectedPlace.types.includes("street_address") === true   )
               setErreurGoogle("OK");
           else
               setErreurGoogle("Manque de précision");


            if (selectedPlace.geometry) {
                placeMarker(selectedPlace.geometry.location);  
                //********** */
                
                changeAddress(selectedPlace);
                //********** */                             
            } else {
                console.error("Invalid place selected");
            }

            const marker = new google.maps.Marker({
                position: selectedPlace.geometry.location,
                map: mapInstance,
                icon: "/ofc.ico", // Remplacez cette URL par l'URL de votre icône
              });
            
      });




        
        //google.maps.event.trigger(autocompleteInstance, 'place_changed');
        //********************************************************* */
        if(defaultAddress !== undefined )    
        {    
              geocodeAddress(defaultAddress , function(location) {              
                      placeMarker(location.geometry.location);
                      setSearchValue(location.formatted_address);  
                      changeAddress(location);

                      if(location.types.includes("subpremise")  === true ||
                         location.types.includes("premise") === true ||
                         location.types.includes("street_address")  === true  )
                          setErreurGoogle("OK");
                      else
                          setErreurGoogle("Manque de précision");


              });
        }
        //********************************************************* */
        
    }).catch(error => {
      console.error("Error loading Google Maps API:", error);
    });
  }, [defaultAddress]);


   function geocodeAddress(address, callback) {
    console.log("address:" + address);
      var geocoder = new window.google.maps.Geocoder();
          geocoder.geocode({ address: address }, function(results, status) {
          setErreurGoogle(status);
        if (status === 'OK') {  
          setErreurGoogle('OK');
          console.log(results[0]); 
          callback(results[0]);
        } else {
          setErreurGoogle("Manque de précision");
          console.error('Geocode was not successful for the following reason: ' + status);
         
        }
      });
    }

    function placeMarker(location) {
      var map = new window.google.maps.Map(document.getElementById('map'), {
        center: location,
        zoom: 17
      });
      var marker = new window.google.maps.Marker({
        position: location,
        map: map
      });
    }
  
  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };


  return (
    <div>
        {erreurGoogle !== "OK" ?  <Typography variant="h5"  color="red">Adresse invalide: {erreurGoogle} </Typography> : null }
        <TextField
          fullWidth 
          type="text"
          id="search-input"
          value={searchValue}
          onChange={handleSearchChange}
          placeholder="Rechercher une adresse"
        />
      

      <div id="map" style={{ width: "400px", height: "400px" }} />
       
      
    </div>
  );
}